export default "__VITE_ASSET__CtmRuKve__"